export default __webpack_public_path__ + "static/media/search.f2d70afd.png";